import { Outlet } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import { useSelector } from "react-redux";

import PosSidebar from "./PosSidebar";
import AppBar from "../MainLayout/AppBar";
import { Main } from "../MainLayout";

// ==============================|| POS LAYOUT ||============================== //

// Same shell as the admin layout, with the POS sidebar and app bar mode.
const PosLayout = () => {
  const leftDrawerOpened = useSelector((state) => state.app.is_drawer_opened);

  return (
    <Box sx={{ display: "flex" }} dir="rtl">
      <CssBaseline />
      <AppBar pos />
      <PosSidebar />
      <Main open={leftDrawerOpened}>
        <Outlet />
      </Main>
    </Box>
  );
};

export default PosLayout;
